import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/Pages/HomePage';
import AboutUs from './components/Pages/AboutUs';
import TourOperators from './components/Pages/OurServices/TourOperators';
import BusTicketBooking from './components/Pages/OurServices/BusTicketBooking';
import TrainTicketBooking from './components/Pages/OurServices/TrainTicketBooking';
import FlightTicketBooking from './components/Pages/OurServices/FlightTicketBooking';
import CarAndCoachRental from './components/Pages/OurServices/CarAndCoachRental';
import OrganizingSchoolTrips from './components/Pages/OurServices/OrganizingSchoolTrips';
import HotelBooking from './components/Pages/OurServices/HotelBooking';
import Tirupati from './components/Pages/TourPackages/Tirupati';
import Shirdi from './components/Pages/TourPackages/Shirdi';
import MaduraiRameshwaram from './components/Pages/TourPackages/MaduraiRameshwaram';
import BangaloreSightSeeing from './components/Pages/TourPackages/BangaloreSightSeeing';
import MysoreSightSeeing from './components/Pages/TourPackages/MysoreSightSeeing';
import MysoreOotyCoonoor from './components/Pages/TourPackages/MysoreOotyCoonoor';
import OotyKodaikanal from './components/Pages/TourPackages/OotyKodaikanal';
import MunnarThekkadyAlleppey from './components/Pages/TourPackages/MunnarThekkadyAlleppey';
import GoaBeachCity from './components/Pages/TourPackages/GoaBeachCity';
import PondicherryMahabalipuram from './components/Pages/TourPackages/PondicherryMahabalipuram';
import CoorgHomeStay from './components/Pages/TourPackages/CoorgHomeStay';
import HyderabadRamoji from './components/Pages/TourPackages/HyderabadRamoji';
import ShimlaManali from './components/Pages/TourPackages/ShimlaManali';
import DelhiAgraJaipur from './components/Pages/TourPackages/DelhiAgraJaipur';
import ContactUs from './components/Pages/ContactUs';
import DynamicSeo from './DynamicSeo';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <DynamicSeo />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />

          {/* Our Services START */}
          <Route path="/tour-operators" element={<TourOperators />} />
          <Route path="/bus-ticket-booking" element={<BusTicketBooking />} />
          <Route path="/train-ticket-booking" element={<TrainTicketBooking />} />
          <Route path="/flight-ticket-booking" element={<FlightTicketBooking />} />
          <Route path="/car-coach-rental" element={<CarAndCoachRental />} />
          <Route path="/organizing-school-college-trips" element={<OrganizingSchoolTrips />} />
          <Route path="/hotel-booking" element={<HotelBooking />} />
          {/* Our Services END */}

          {/* Tour Packages START */}
          <Route path="/tirupati-balaji-sheegra-darshan" element={<Tirupati />} />
          <Route path="/shirdi-shanisinganapur" element={<Shirdi />} />
          <Route path="/madurai-rameshwaram-kanyakumari" element={<MaduraiRameshwaram />} />
          <Route path="/bangalore-sight-seeing" element={<BangaloreSightSeeing />} />
          <Route path="/mysore-sight-seeing" element={<MysoreSightSeeing />} />
          <Route path="/mysore-ooty-coonoor" element={<MysoreOotyCoonoor />} />
          <Route path="/ooty-kodaikanal" element={<OotyKodaikanal />} />
          <Route path="/munnar-thekkady-alleppey-cochin" element={<MunnarThekkadyAlleppey />} />
          <Route path="/goa-beach-city" element={<GoaBeachCity />} />
          <Route path="/pondicherry-mahabalipuram" element={<PondicherryMahabalipuram />} />
          <Route path="/coorg-with-home-stay" element={<CoorgHomeStay />} />
          <Route path="/hyderabad-ramoji-film-city" element={<HyderabadRamoji />} />
          <Route path="/shimla-kullu-manali" element={<ShimlaManali />} />
          <Route path="/delhi-agra-jaipur" element={<DelhiAgraJaipur />} />
          {/* Tour Packages END */}
        </Routes>
      </BrowserRouter>
      {/* <CssBaseline /> */}

    </ThemeProvider>
  );
}

export default App;
